var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor",style:({transform: ("translate3d(" + (_vm.offset.x) + "px, " + (_vm.offset.y) + "px, 0)")})},[_c('icon',{style:({color: _vm.color}),attrs:{"name":"cursor"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }